import React from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import RightSidebar from "../components/common-components/right_sidebar";
import UpperProgressBar from "../components/common-components/UpperProgressBar";
import { authServices } from "../services/auth.services";
import { useState } from "react";
import { SetUserDetailsToLocal } from "../services/utils";
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { GetPageTittle } from "../services/utils";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../services/utils";
import LoadingBar from "../components/common-components/toaster/loader/loader";
const Signup = () => {
    const navigate = useNavigate()
    const role = GetPageTittle()
    const [validate, setValidate] = useState({ ispassword: "" })
    const [showPass, setShowPass] = useState(false)
    const [form, FormData] = useState({ role: role.toLowerCase() })
    const [pageutils, SetPageUtils] = useState({ loading: false })
    const [email, setEmail] = useState(false)
    const [submit, setSubmit] = useState(false)

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        FormData({
            ...form,
            [name]: value
        })
    }

    const SignMeUp = (e) => {
        e.preventDefault()
        SetPageUtils(prev => ({ ...prev, loading: true }))
        if (email) {
            authServices.SignUp(form).then(resp => {
                SetPageUtils(prev => ({ ...prev, loading: false }))
                SetUserDetailsToLocal(resp)
                navigate('/select-user')
            }).catch(err => {
                SetPageUtils(prev => ({ ...prev, loading: false }))
                toast.error(err.response.data.errors.msg)
            }
            )
        }
        SetPageUtils(prev => ({ ...prev, loading: false }))
    }


    return (
        <div className="signup_pg">
            <Container fluid>
                {pageutils.loading && < LoadingBar />
                }
                <UpperProgressBar step={1} now={33.3} />
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Register</h2>
                                </div>
                                <Form className="signform_div" onSubmit={(e) => {
                                    setSubmit(true)
                                    SignMeUp(e)
                                }}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                    >
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            onChange={(e) => {
                                                handleChange(e)
                                                if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email) && form.email !== "") {
                                                    setEmail(true)
                                                }
                                                else {
                                                    setEmail(false)
                                                }
                                            }}
                                            name='email'
                                            type="email"
                                            placeholder="Enter Email"
                                            required
                                        />
                                        {submit && !email &&
                                            <h8 style={{ "color": "red" }}>Invalid Email</h8>
                                        }
                                    </Form.Group>

                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword"
                                    >
                                        <Form.Label>Password</Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                className="pass-field"
                                                onChange={(e) => {
                                                    const res = validatePassword(e.target.value)
                                                    if (res != false) {
                                                        setValidate({ ...validate, ispassword: "" })
                                                    }
                                                    else {
                                                        setValidate({ ...validate, ispassword: "  Minimum 8 characters, at least one alpha, special, numeric, upper & lower case" })
                                                    }
                                                    handleChange(e)
                                                }}
                                                required
                                                name='password'
                                                type={showPass ? "text" : "password"}
                                                placeholder="Enter Password"
                                            />
                                            {showPass ? <FaEyeSlash onClick={() => { setShowPass(!showPass) }} className="sign_upPass" /> :
                                                <FaEye onClick={() => { setShowPass(!showPass) }} className="sign_upPass" />}
                                        </div>
                                        <Form.Text className="text-muted">
                                            {validate.ispassword}
                                        </Form.Text>

                                    </Form.Group>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicCheckbox"
                                    >
                                        <Form.Check type="checkbox">
                                            <Form.Check.Input
                                                name='Terms'
                                                required
                                                type="checkbox" />
                                            <Form.Check.Label>
                                                <p className="sign_agree">
                                                    By signing up, you are
                                                    indicating that you have
                                                    read and agree to the{" "}
                                                    <span
                                                        onClick={() => navigate("/")}
                                                        className="bld_link"
                                                    >
                                                        Terms of Use
                                                    </span>{" "}
                                                    and{" "}
                                                    <span
                                                        onClick={() => navigate("#")}
                                                        className="bld_link"
                                                    >
                                                        Privacy Policy
                                                    </span>
                                                </p>
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </Form.Group>
                                    <Button
                                        className="btn_theme w-100 mt-4"
                                        variant=""
                                        type="submit"
                                    >
                                        Get Started
                                    </Button>
                                    <p className="sign_agree text-center mt-2">
                                        Already have an account?{" "}
                                        <span style={{ cursor: "pointer" }} onClick={() => navigate("/signin")} className="bld_link">Log In here</span>.
                                    </p>
                                </Form>
                            </div>
                        </Col>

                        <RightSidebar step={1} />

                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default Signup;
